import { createTaskFilterFunction, RunbookFilterType } from './filters'
import { TaskListTask } from 'main/services/queries/types'

export const completionType = createTaskFilterFunction(
  'ct',
  (task: TaskListTask, filters: RunbookFilterType): boolean => {
    return filters.ct?.indexOf(task.completion_type) !== -1
  }
)
